import O365SettingsRestService from '../O365SettingsRestService'
import { TFunction } from 'i18next'

class O365SettingsService {
  static async getO365Settings() {
    try {
      var baseSettings = await O365SettingsRestService.getO365BaseSettings()
      if (baseSettings.clientId) {
        const spAndOdSettings = await O365SettingsRestService.getSpAndOdSettings()
        Object.assign(baseSettings, spAndOdSettings)
      }
      return baseSettings
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getO365BaseSettings() {
    return O365SettingsRestService.getO365BaseSettings()
  }

  static async configureO365BaseSettings(o365Settings: any, t: TFunction, setO365Settings: React.Dispatch<any>) {
    try {
      var config = Object.assign({}, o365Settings)
      config.internalDomains = o365Settings.internalDomains?.split(',').map((internalDomain: string) => internalDomain.trim())
      await O365SettingsRestService.configureO365Settings(config)
      const updatedConfig = await O365SettingsService.getO365Settings()
      setO365Settings(updatedConfig)
      return t('o365Setting.configureSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async configureSpAndOdSettings(spAndOdSettings: any, t: TFunction, setO365Settings: React.Dispatch<any>) {
    try {
      await O365SettingsRestService.configureSpAndOdSettingsSettings(spAndOdSettings)
      const updatedConfig = await O365SettingsService.getO365Settings()
      setO365Settings(updatedConfig)
      return t('o365Setting.configureSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default O365SettingsService
